import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CookieService } from 'ngx-cookie-service'
import { environment } from '../../../environments/environment'

@Injectable()
export class EstabelecimentoValidarService {
    constructor(
        private httpClient: HttpClient,
        private cookieService: CookieService
    ) {}

    validar(nomeOperadora, numero) {
        const url = `${environment.collectJsonApiBaseUrl}/validar-estabelecimento`;
        const body = { nomeOperadora, numero };

        const jwt = this.cookieService.get('jwt')
        const headers = { Authorization: `Bearer ${jwt}` }
        return this.httpClient.post(url, body, { headers });
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/shared/estabelecimento-validar.service.ts